import React, { useCallback, useState } from 'react';
import { Show } from '../../../../../../shared/Show';
import { AddContactForm } from '../../../shared/AddContactForm';
import { RateField } from '../../notaryStep/notaryForm/RateField';
import { useFormikContext } from 'formik';
import { INotesFormData } from './NotesForm';
import { CreateSigningAppointmentFormData } from '../../../04_confirmationStep/convertToCreateSigningAppointmentRequest';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStamp } from '@fortawesome/pro-regular-svg-icons';
import { IconPlusOutline } from '@zillow/constellation-icons';
import { css } from '@/styled-system/css';
import { Button } from '@zillow/constellation-10';

interface NotesNotarySectionProps {
  hasNotary: boolean;
  formTitle: string;
  updatedWizardFormData: CreateSigningAppointmentFormData;
}
export const NotesNotarySection: React.FC<NotesNotarySectionProps> = ({
  formTitle,
  hasNotary,
  updatedWizardFormData,
}) => {
  const { values, setValues } = useFormikContext<INotesFormData>();
  const [showNotaryForm, setShowNotaryForm] = useState<boolean>(!!values.notary);
  const onTrashIconClick = useCallback(() => {
    setValues({ ...values, notary: undefined });
    setShowNotaryForm(false);
  }, [setValues, values, setShowNotaryForm]);

  const onAddNotaryClick = useCallback(() => {
    setValues({ ...values, notary: { firstName: '', lastName: '', phoneNumber: '', email: '' } });
    setShowNotaryForm(true);
  }, [setValues, values, setShowNotaryForm]);

  if (!hasNotary) {
    return null;
  }
  return (
    <Show
      when={showNotaryForm}
      fallback={
        <section
          className={css({
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8',
          })}
          data-test-id="no-notaries-section"
        >
          <FontAwesomeIcon className={css({ height: '48', width: '48', color: '#4A4D7D' })} icon={faStamp} />
          <Button
            tone={'brand'}
            emphasis={'filled'}
            size="sm"
            icon={<IconPlusOutline />}
            iconPosition="start"
            onClick={onAddNotaryClick}
          >
            <p>{formTitle}</p>
          </Button>
        </section>
      }
    >
      <AddContactForm
        isSigner={false}
        title={formTitle}
        notary={values.notary}
        onTrashIconClick={onTrashIconClick}
        emailRequired={false}
        isLegacy={!updatedWizardFormData.isDigitalScheduling}
      >
        <RateField wizardFormData={updatedWizardFormData} />
      </AddContactForm>
    </Show>
  );
};
